import { render, staticRenderFns } from "./showButtons.vue?vue&type=template&id=4e7ac8bd"
import script from "./showButtons.vue?vue&type=script&lang=js"
export * from "./showButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports